import * as React from 'react';
import { connect } from 'react-redux';

import { ICrop, IDocument } from '../../infrastructure/interfaces';
import CropsEditorForm from '../DocumentEditor/CropsEditorForm';
import {
  toggleCrop,
  changeCropImage,
} from '../../actions/actions';

export interface ICropsChoosingProps {
  document: IDocument;
  crops: ICrop[];
  toggleCrop(crop: ICrop): void;
  changeCropImage(crop: ICrop, image: string): void;
}

export interface ICropsChoosingState extends React.ComponentState {
  showModal: boolean;
  editCrop: ICrop;
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    toggleCrop: (crop: ICrop): void => {
      dispatch(toggleCrop(crop));
    },
    changeCropImage: (crop: ICrop, image: string): void => {
      dispatch(changeCropImage(crop, image));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
    crops: state.wizard.crops,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class CropsChoosing extends React.Component<any, any> {
  constructor(props: ICropsChoosingProps) {
    super(props);
  }
  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            Choose 1, 2 or 3 crops for cover photos:
          </div>
          <div className="stepMessage2">
            You can change this selection later.
          </div>
        </div>

        <CropsEditorForm
          className="settingsCropsListContainer settingsCropsListContainer--crops"
          document={this.props.document}
          crops={this.props.crops}
          toggleCrop={this.props.toggleCrop}
          changeCropImage={this.props.changeCropImage}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Steps/CropsChoosing.tsx